if (!customElements.get('s-main-collection')) {
  customElements.define('s-main-collection', class SectionMainCollection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.productList = this.querySelector(".js-main-collection__list");
        this.sort = this.querySelector(".js-main-collection__sort-wrapper");
        this.filterGroups = Array.from(this.querySelectorAll(".js-main-collection__filter-group"));
        this.paginations = Array.from(this.querySelectorAll(".js-main-collection__pagination"));

        this.mobileContainer = this.querySelector(".js-main-collection__mobile-wrapper")
        this.stickyContainers = [this.sort, this.mobileContainer].filter(Boolean);
        this.stickyWatcher = this.updateStickyState.bind(this);

        this.variablesInit()
        this.updateStickyState()
        window.addEventListener("scroll", this.stickyWatcher, { passive: true })
        window.addEventListener("resize", this.stickyWatcher)

        subscribe("filter-changer", this.inputChanger)
        subscribe("sort-changer", this.sortHandler)
      }

      disconnectedCallback() {
        this.inputs.forEach(input => {
          input.removeEventListener("change", this.inputChanger)
        });
        
        this.sortSelect.removeEventListener("change", this.sortHandler);
        this.filterButton.removeEventListener("click", this.filterOpener)
        window.removeEventListener("scroll", this.stickyWatcher)
        window.removeEventListener("resize", this.stickyWatcher)
      }

      updateStickyState() {
        const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--header-height")) || 0;
        let isAnySticky = false;

        this.stickyContainers.forEach(container => {
          if (!container || getComputedStyle(container).display === "none") {
            container?.classList.remove("is-sticky");
            return;
          }

          const rect = container.getBoundingClientRect();
          const isSticky = rect.top <= headerHeight + 1 && rect.bottom > headerHeight;
          container.classList.toggle("is-sticky", isSticky);
          isAnySticky = isAnySticky || isSticky;
        });

        document.body.classList.toggle("collection-filters-stuck", isAnySticky);
      }

      filterOpener = () => {
        publish("open-filter-modal")
      }

      variablesInit = () => {
        if (this.inputs) {
          this.inputs.forEach(input => {
            input.removeEventListener("change", this.inputChanger);
          });
        }

        if (this.sortSelect) {
          this.sortSelect.removeEventListener("change", this.sortHandler);
        }

        if (this.filterButton) {
          this.filterButton.removeEventListener("click", this.filterOpener)
        }

        this.inputs = Array.from(this.querySelectorAll(".js-main-collection__filter-value"));

        this.sortSelect = this.querySelector(".js-main-collection__sort-select")

        this.inputs.forEach(input => {
          input.addEventListener("change", this.inputChanger)
        });

        this.sortSelect.addEventListener("change", this.sortHandler);


        this.filterButton = this.querySelector(".js-main-collection__modal-button");

        this.filterButton.addEventListener("click", this.filterOpener)
      }

      sortHandler = event => {
        let value = event.target.value;

        const url = new URL(window.location.href);
        const params = url.searchParams;
    
        if (params.has('sort_by')) {
            params.set('sort_by', value);
        } else {
            params.append('sort_by', value);
        }
    
        this.filterChangeHandler(`${url.pathname}?${params.toString()}`)
      }

      inputChanger = (event) => {
        let input = event.target
        let updatedUrl = input.checked ? input.dataset.filterAdd : input.dataset.filterRemove;

        this.classList.add("is-loading")
        this.filterChangeHandler(updatedUrl)
      }

      filterChangeHandler = (updatedUrl) => {
        fetch(updatedUrl)
        .then(res => res.text())
        .then(response => {
          let newDom = new DOMParser().parseFromString(response, "text/html");

          let newSection = newDom.querySelector("s-main-collection");
          let newFilterGroups = Array.from(newSection.querySelectorAll(".js-main-collection__filter-group"))  
        
          this.filterGroups.forEach((group, i) => {
            group.innerHTML = newFilterGroups[i].innerHTML;
          })

          this.productList.innerHTML = newSection.querySelector(".js-main-collection__list").innerHTML;
          this.sort.innerHTML = newSection.querySelector(".js-main-collection__sort-wrapper").innerHTML;

          let newPaginations = Array.from(newSection.querySelectorAll(".js-main-collection__pagination"));
          this.paginations.forEach((pagination, i) => {
            pagination.innerHTML = newPaginations[i].innerHTML;
          })

          this.mobileContainer.innerHTML = newSection.querySelector(".js-main-collection__mobile-wrapper").innerHTML;

          publish("update-filter", newDom)

          this.variablesInit();
          this.updateStickyState();

          window.history.pushState(null, '', updatedUrl);
        })
        .finally(() => {
          this.classList.remove("is-loading")
        })
        .catch(error => {
          console.log(error)
        })
      }
    }
  );
}
